import { productsMatcher } from "../../../utils/productsMatcher";
import { getBlockedProductIdsForSelectedIds } from "../../../common/onBoardingWizardFieldTypes/cameraProductsMutualExclusion";

export const handleCheckBoxClick = (
  productName: string,
  setCamerasObject: any,
  camerasObject: any,
  objectId: number,
  checked: boolean,
  productsArray: any[]
) => {
  const productId = productsMatcher("Id", productName, productsArray);
  if (productId === undefined || productId === null) {
    return;
  }

  const currentProducts: number[] = [...(camerasObject[objectId]?.products || [])];
  const blockedProductIds = getBlockedProductIdsForSelectedIds(
    currentProducts,
    productsArray
  );

  if (checked && blockedProductIds.has(productId)) {
    return;
  }

  const nextProducts = checked
    ? currentProducts.includes(productId)
      ? currentProducts
      : [...currentProducts, productId]
    : currentProducts.filter((id: number) => id !== productId);

  setCamerasObject((previousState: any) => ({
    ...previousState,
    [objectId]: {
      ...previousState[objectId],
      products: nextProducts,
    },
  }));
};
